/* eslint-disable @typescript-eslint/no-non-null-assertion */
import PREFIX from '../prefix';
import { $el, bind, createElem, setCss, setHtml } from '../../dom-utils';
import { destroyElem, type, useHTMLString } from '../../utils';
import { CssTransition } from '../../mixins';
export var PREFIX_KEY = 'rab-message-instance';
export var EnterClass = PREFIX.message + "-move-enter";
export var LeaveClass = PREFIX.message + "-move-leave";
var ICONTYPES = {
    info: 'ios-information-circle',
    success: 'ios-checkmark-circle',
    warning: 'ios-alert',
    error: 'ios-close-circle',
    loading: 'loading-solid'
};
var zIndex = 1010;
var name = 0;
var CreateInstance = /** @class */ (function () {
    function CreateInstance() {
        this.INSTANCES = [];
    }
    CreateInstance.prototype._init = function (top) {
        var Wrapper = createElem('div');
        setCss(Wrapper, 'zIndex', "" + zIndex);
        Wrapper.setAttribute('class', "" + PREFIX.message);
        document.body.appendChild(Wrapper);
        setTimeout(function () { return setCss(Wrapper, 'top', top + "px"); }, 0);
    };
    CreateInstance.prototype._create = function (type, config, duration) {
        var Message = this._setMainTemplate(type);
        var MessageContent = Message.querySelector("." + PREFIX.messageChild + "-content");
        this._autoAddZIndex();
        this._setIcon(type, Message);
        this._setContent(Message, config);
        if (typeof config === 'object') {
            var key = config.key, closable = config.closable, onClose = config.onClose, background = config.background;
            this._setKey(Message, key);
            this._setClosable(Message, MessageContent, closable, onClose);
            this._setBackground(Message, MessageContent, background);
        }
        this.INSTANCES.push(Message);
        $el("." + PREFIX.message).appendChild(Message);
        this._autoClose(Message, config, duration);
    };
    CreateInstance.prototype._setMainTemplate = function (type) {
        var MessageNotice = createElem('div');
        var template = "\n        <div class=\"" + PREFIX.messageChild + "-content " + PREFIX.messageChild + "-content-" + type + "\">\n            <div class=\"" + PREFIX.messageChild + "-content-text\">\n                <div class=\"" + PREFIX.message + "-" + type + "\">\n                    <i class=\"" + PREFIX.icon + "\"></i>\n                    <span id=\"" + PREFIX.messageChild + "-text\"></span>\n                </div>\n            </div>\n        </div>\n      ";
        MessageNotice.dataset['thisName'] = "" + name++;
        MessageNotice.className = PREFIX.message + "-notice";
        setHtml(MessageNotice, template);
        CssTransition(MessageNotice, {
            inOrOut: 'in',
            enterCls: EnterClass,
            rmCls: true,
            timeout: 250
        });
        return MessageNotice;
    };
    CreateInstance.prototype._setIcon = function (type, elem) {
        var MessageIcon = elem.querySelector("." + PREFIX.icon);
        if (type === 'loading') {
            MessageIcon.classList.add('rab-load-loop');
        }
        MessageIcon.classList.add(PREFIX.icon + "-" + ICONTYPES[type]);
    };
    CreateInstance.prototype._setContent = function (elem, content) {
        var MessageText = elem.querySelector("#" + PREFIX.messageChild + "-text");
        if (typeof content === 'string') {
            useHTMLString(MessageText, content, false);
        }
        else if (typeof content === 'object' && content.content) {
            useHTMLString(MessageText, content.content, content.dangerouslyUseHTMLString);
        }
    };
    CreateInstance.prototype._setKey = function (elem, key) {
        if (!key || (key && !type.isStr(key) && !type.isNum(key)))
            return;
        elem.setAttribute(PREFIX_KEY + "-key", "" + key);
    };
    CreateInstance.prototype._setClosable = function (elem, child, closable, onClose) {
        if (!closable || (closable && !type.isBol(closable)))
            return;
        var template = "\n        <a class=\"" + PREFIX.messageChild + "-close\">\n          <i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-ios-close\"></i>\n        </a>\n        ";
        elem.classList.add(PREFIX.messageChild + "-closable");
        child.insertAdjacentHTML('beforeend', template);
        this._handleClose(elem, onClose);
    };
    CreateInstance.prototype._handleClose = function (elem, onClose) {
        var _this = this;
        var MessageCloseBtn = elem.querySelector("." + PREFIX.messageChild + "-close");
        bind(MessageCloseBtn, 'click', function () {
            _this._destroy(elem);
            onClose && type.isFn(onClose);
        });
    };
    CreateInstance.prototype._setBackground = function (elem, child, background) {
        if (!background || (background && !type.isBol(background)))
            return;
        elem.classList.add(PREFIX.messageChild + "-with-background");
        child.classList.add(PREFIX.messageChild + "-content-background");
    };
    CreateInstance.prototype._autoAddZIndex = function () {
        zIndex++;
        setCss($el("." + PREFIX.message), 'zIndex', "" + zIndex);
    };
    CreateInstance.prototype._autoClose = function (elem, config, duration) {
        var _this = this;
        if (duration || duration === 0 || !config) {
            if (duration === 0)
                return;
            setTimeout(function () {
                _this._destroy(elem);
            }, duration * 1000);
        }
        else {
            if (typeof config === 'object' && config.duration) {
                setTimeout(function () {
                    _this._destroy(elem);
                }, config.duration * 1000);
            }
        }
    };
    CreateInstance.prototype._destroy = function (elem) {
        destroyElem(elem, {
            duration: 0.1,
            clsEnter: EnterClass,
            clsLeave: LeaveClass
        });
        this.INSTANCES.splice(Number(elem.dataset['thisName']), 1);
    };
    return CreateInstance;
}());
export { CreateInstance };
